import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useDB } from '../../../contexts/DBContext';
import styles from './Footer.module.scss';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  FaFacebookF,
  FaInstagram,
  FaPhone,
  FaArrowLeft,
  FaTimes,
} from 'react-icons/fa';

const Footer = () => {
  const { lang } = useParams();
  const { t } = useTranslation();
  const { pdf } = useDB();
  const location = useLocation();

  return (
    <Container fluid className={styles.footerWrap}>
      <Container className={styles.sectionWrap}>
        <Row className={styles.wrap}>
          <div className={styles.left}>
            <div className={styles.inner}>
              <div className={styles.imgWrap}>
                <img
                  src={require('../../../images/mt-logo-orange.png')}
                  alt='logo'
                />
              </div>
            </div>
          </div>
          <div className={styles.right}>
            <div className={styles.linki}>
              <Link to={`/${lang}/terms/faqs`} state={{ previousLocation: location }}>
                {t('page_faqs')}
              </Link>
              <Link
                to={`/${lang}/terms/cookies`}
                state={{ previousLocation: location }}
              >
                {t('page_cookies')}
              </Link>
              <Link
                to={`/${lang}/terms/privacy`}
                state={{ previousLocation: location }}
              >
                {t('page_privacy')}
              </Link>
              <Link
                to={`/${lang}/terms/tcs`}
                state={{ previousLocation: location }}
              >
                {t('page_tcs')}
              </Link>
            </div>
          </div>
        </Row>
        <Row className={styles.wrap}>
          <div className={styles.left}>
            <p>
              <span>Copyright © {new Date().getFullYear()}</span> ModernTribe
            </p>
          </div>
          <div className={styles.right}>
            <div className={styles.linki}>
              <a
                style={{
                  cursor: 'pointer',
                  textUnderlineOffset: '.25rem',
                }}
                href='https://www.linkedin.com/in/jakub-blazewicz/'
                target='_blank'
              >
                {t('made_with')} 🤍
              </a>
            </div>
          </div>
        </Row>
      </Container>
    </Container>
  );
};

export default Footer;
